import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    closeOnOutsideClick: { type: Boolean, default: true },
    group: String
  }

  connect() {
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleToggle = this.handleToggle.bind(this)

    if (this.closeOnOutsideClickValue) {
      document.addEventListener("click", this.handleDocumentClick)
    }

    document.addEventListener("keydown", this.handleKeydown)

    if (this.detailsElement) {
      this.element.addEventListener("toggle", this.handleToggle)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick)
    document.removeEventListener("keydown", this.handleKeydown)

    if (this.detailsElement) {
      this.element.removeEventListener("toggle", this.handleToggle)
    }
  }

  close() {
    this.closeElement()
  }

  handleDocumentClick(event) {
    if (!this.isOpen || this.element.contains(event.target)) return

    this.closeElement()
  }

  handleKeydown(event) {
    if (event.key !== "Escape" || !this.isOpen) return

    this.closeElement()
  }

  handleToggle() {
    if (!this.isOpen || !this.hasGroupValue) return

    this.closeGroupPeers()
  }

  closeGroupPeers() {
    const group = window.CSS?.escape ? CSS.escape(this.groupValue) : this.groupValue
    const selector = `[data-controller~="disclosure"][data-disclosure-group-value="${group}"]`

    document.querySelectorAll(selector).forEach((element) => {
      if (element === this.element || !(element instanceof HTMLDetailsElement)) return

      element.open = false
    })
  }

  closeElement() {
    if (this.detailsElement) {
      this.element.open = false
    }
  }

  get detailsElement() {
    return this.element instanceof HTMLDetailsElement
  }

  get isOpen() {
    return this.detailsElement && this.element.open
  }
}
